import { MDBBtn } from "mdb-react-ui-kit";
import { useSpring, animated, easings } from "react-spring";
import Smile from "./Smile";
import SignRed from "../../images/SignRed.svg";

const Cover = () => {
  // spring motions
  const Spring = useSpring({
    config: {
      easing: easings.easeInExpo,
      mass: 1,
    },
    from: {
      opacity: 0,
      filter: "saturate(50%) brightness(50%)",
      scale: "0.3",
      transform: "translate3d(0,-300px,20px)",
    },
    opacity: 1,
    filter: "saturate(100%) brightness(100%)",
    scale: "1",
    transform: "translate3d(0,0,0)",
    delay: 2000,
  });
  const SpringBTN = useSpring({
    config: {
      // easing: easings.easeInExpo,
      // mass: 1.5,
      duration: 1500,
    },
    from: {
      opacity: 0,
      // transform: "translate3d(-2000px,0,0)",
    },
    opacity: 1,
    // transform: "translate3d(0,0,0)",
    delay: 2500,
  });

  return (
    <div className="firstRow ">
      {/* FA row */}
      <animated.div style={SpringBTN} className="row w-100 text-end pt-4">
        <a href="https://about.digikala.com/1400-report/digikala-report-1400/">
          <MDBBtn id="btnFA" outline className="btn-outlined mid-btn ">
            FA
          </MDBBtn>
        </a>
      </animated.div>
      <div className="d-flex flex-column h-100 justify-content-center align-items-center text-center">
        <div>
          <Smile />
          {/* <Sign /> */}

          <animated.div style={Spring}>
            <img
              src={SignRed}
              alt="Digilaka"
              style={{ width: "220px", marginBottom: "15px" }}
            />
          </animated.div>
          {/* Typography */}
          <animated.div style={Spring}>
            <h2
              style={{
                fontSize: "26px",
                fontWeight: "600",
              }}
            >
              and Boomi Mahalli
            </h2>
            <p
              className="mt-3"
              style={{
                fontSize: "21px",
                fontWeight: "500",
              }}
            >
              Annual Report 2021-22
            </p>
          </animated.div>
        </div>
        {/* Download BTN */}
        <div style={{ marginTop: "30px" }}>
          <animated.div style={SpringBTN}>
            <a
              target="_blank"
              rel="noreferrer"
              href={process.env.PUBLIC_URL + "/DigikalaAnualReport2122EN.pdf"}
            >
              <MDBBtn
                color="info"
                className="d-flex justify-content-around align-items-center btn-filled big-btn p-0"
                style={{ width: "220px" }}
              >
                Download Full Version
              </MDBBtn>
            </a>
          </animated.div>
        </div>
      </div>
    </div>
  );
};

export default Cover;
